import React, { useEffect, useState } from 'react';
import { Shield, Lock, CreditCard, Zap } from 'lucide-react';
export function FinalPricing() {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 33,
    s: 41
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) {
          s--;
        } else {
          s = 59;
          if (m > 0) {
            m--;
          } else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (num: number) => num.toString().padStart(2, '0');
  return <section className="w-full bg-brand-blue py-16 md:py-24 px-4 text-white" data-id="element-138">
      <div className="max-w-6xl mx-auto" data-id="element-139">
        <div className="text-center mb-12" data-id="element-140">
          <h2 className="text-2xl md:text-3xl font-bold mb-6" data-id="element-141">
            ⏰ El precio de lanzamiento cierra en:
          </h2>

          <div className="flex justify-center gap-4 mb-6" data-id="element-142">
            <div className="flex flex-col items-center" data-id="element-143">
              <div className="bg-slate-900 text-white text-4xl md:text-5xl font-bold p-4 rounded-lg min-w-[80px]" data-id="element-144">
                {format(timeLeft.h)}
              </div>
            </div>
            <div className="text-4xl md:text-5xl font-bold py-4" data-id="element-145">:</div>
            <div className="flex flex-col items-center" data-id="element-146">
              <div className="bg-slate-900 text-white text-4xl md:text-5xl font-bold p-4 rounded-lg min-w-[80px]" data-id="element-147">
                {format(timeLeft.m)}
              </div>
            </div>
            <div className="text-4xl md:text-5xl font-bold py-4" data-id="element-148">:</div>
            <div className="flex flex-col items-center" data-id="element-149">
              <div className="bg-slate-900 text-white text-4xl md:text-5xl font-bold p-4 rounded-lg min-w-[80px]" data-id="element-150">
                {format(timeLeft.s)}
              </div>
            </div>
          </div>

          <p className="text-xl text-blue-200 font-medium" data-id="element-151">
            Después sube $15.000 ARS y no vuelve.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-152">
          {/* Card 1 */}
          <div className="bg-slate-800 rounded-2xl p-6 border border-slate-700 shadow-lg flex flex-col" data-id="element-153">
            <div className="font-bold text-white mb-4" data-id="element-154">
              ✅ MÉDICO EN PROCESO™
            </div>
            <div className="mb-6 flex-grow" data-id="element-155">
              <div className="text-slate-400 line-through text-sm" data-id="element-156">
                $58.990 ARS
              </div>
              <div className="text-3xl font-bold text-green-400" data-id="element-157">
                $19.990 ARS
              </div>
            </div>
            <button className="w-full bg-brand-amber hover:bg-amber-600 text-white font-bold py-4 rounded-xl shadow-md transition-transform hover:scale-105 active:scale-95 min-h-[56px]" data-id="element-158">
              → ELEGIR ESTE
            </button>
          </div>

          {/* Card 2 */}
          <div className="bg-slate-800 rounded-2xl p-6 border-2 border-blue-400 shadow-xl flex flex-col relative transform md:-translate-y-2" data-id="element-159">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-blue-500 text-white font-bold px-3 py-1 rounded-full text-xs whitespace-nowrap" data-id="element-160">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="font-bold text-blue-400 mb-4 mt-2" data-id="element-161">
              ⭐ CARRERA ORGANIZADA™
            </div>
            <div className="mb-6 flex-grow" data-id="element-162">
              <div className="text-slate-400 line-through text-sm" data-id="element-163">
                $102.990 ARS
              </div>
              <div className="text-3xl font-bold text-green-400" data-id="element-164">
                $27.990 ARS
              </div>
            </div>
            <button className="w-full bg-brand-amber hover:bg-amber-600 text-white font-bold py-4 rounded-xl shadow-md transition-transform hover:scale-105 active:scale-95 min-h-[56px]" data-id="element-165">
              → ELEGIR ESTE
            </button>
          </div>

          {/* Card 3 */}
          <div className="bg-slate-800 rounded-2xl p-6 border-2 border-brand-amber shadow-xl flex flex-col relative" data-id="element-166">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-amber text-white font-bold px-3 py-1 rounded-full text-xs whitespace-nowrap" data-id="element-167">
              🏆 MÁS COMPLETO
            </div>
            <div className="font-bold text-brand-amber mb-4 mt-2" data-id="element-168">
              🏆 GESTIÓN ACADÉMICA™
            </div>
            <div className="mb-6 flex-grow" data-id="element-169">
              <div className="text-slate-400 line-through text-sm" data-id="element-170">
                $149.990 ARS
              </div>
              <div className="text-3xl font-bold text-green-400" data-id="element-171">
                $32.990 ARS
              </div>
            </div>
            <button className="w-full bg-brand-amber hover:bg-amber-600 text-white font-bold py-4 rounded-xl shadow-md transition-transform hover:scale-105 active:scale-95 min-h-[56px]" data-id="element-172">
              → ELEGIR ESTE
            </button>
          </div>
        </div>

        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-sm text-blue-200 font-medium" data-id="element-173">
          <span className="flex items-center gap-1" data-id="element-174">
            <Lock size={16} data-id="element-175" /> Pago 100% seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-176">
            <Zap size={16} data-id="element-177" /> Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-1" data-id="element-178">
            <Shield size={16} data-id="element-179" /> Garantía 7 días sin preguntas
          </span>
          <span className="flex items-center gap-1" data-id="element-180">
            <CreditCard size={16} data-id="element-181" /> Mercado Pago | Tarjeta | Transferencia
          </span>
        </div>
      </div>
    </section>;
}